module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00439.85949ced.jpg";